import { useState, useCallback } from "react";
import useAccountForm from "../../MyCompany/components/hooks/useAccountForm";
import useMobileMoneyVerification from "../../MyCompany/components/hooks/useMobileMoneyVerification";
import createAccountSubmitHandler from "../../MyCompany/components/utils/accountSubmitHandler";
import { useCreateMerchantInstitutionMobileMoneyAccount } from "../../../hooks/queries/useMerchantQueries";

export const useMobileMoneyModal = () => {
  const [selectedMerchantInstitution, setSelectedMerchantInstitution] =
    useState(null);

  const {
    control,
    handleSubmit: submitMobileForm,
    reset: resetMobileForm,
    setValue,
  } = useAccountForm("mobile");

  const {
    handleBlur: handleMsisdnBlur,
    handleMsisdnChange,
    handleProviderChange,
    resetVerification,
    isVerifying,
    isVerified,
    isUnverified,
    message: verificationMessage,
  } = useMobileMoneyVerification({ setValue });

  const { mutate, isPending } = useCreateMerchantInstitutionMobileMoneyAccount();

  const openModal = useCallback((merchant) => {
    setSelectedMerchantInstitution(merchant);
  }, []);

  const closeModal = useCallback(() => {
    setSelectedMerchantInstitution(null);
    resetMobileForm();
    resetVerification();
  }, [resetMobileForm, resetVerification]);

  const onSubmit = createAccountSubmitHandler(
    mutate,
    (accountData) => {
      if (!selectedMerchantInstitution) {
        throw new Error("No merchant selected");
      }
      return {
        merchantId: selectedMerchantInstitution.merchantId,
        accountData,
      };
    },
    () => {
      closeModal();
      resetMobileForm();
      resetVerification();
    },
    "mobile",
  );

  const handleSubmit = submitMobileForm(onSubmit);

  const isOpen = !!selectedMerchantInstitution;

  const disableSubmit = isPending;

  return {
    isOpen,
    selectedMerchantInstitution,
    openModal,
    closeModal,
    handleSubmit,
    control,
    isCreating: isPending,
    disableSubmit,
    handleMsisdnBlur,
    handleMsisdnChange,
    handleProviderChange,
    isVerifying,
    isVerified,
    isUnverified,
    verificationMessage,
  };
};

export default useMobileMoneyModal;
